"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const legalDisclaimerInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Legal notice",
  },
  {
    name: "description",
    type: "string",
    required: true,
    defaultValue: "Description...",
  },
  {
    name: "linkLabel",
    type: "string",
    required: true,
    defaultValue: "View more",
  },
  {
    name: "href",
    type: "url",
    required: true,
    defaultValue: "#",
  },
] as const satisfies Inputs;

export const LegalDisclaimerComponent: RegisteredComponent = {
  name: "LegalDisclaimer",
  component: dynamic(async () =>
    withValidation(legalDisclaimerInputs, (await import("./LegalDisclaimer")).LegalDisclaimer, "LegalDisclaimer")
  ),
  inputs: legalDisclaimerInputs,
};
